<!--
 * @Description: 列表
-->
<template>
  <a-card class="table_area_wrapper">
    <div class="mb-10 btn_group_wrapper">
      <a-button type="primary" v-if="couldEdit" @click="handleAdd()">新增检测点</a-button>
    </div>

    <div class="custom_vxe_table_wrapper">
      <vxe-table height="auto" :data="tableData" :loading="loading">
        <vxe-column title="检测点序号" field="number"></vxe-column>
        <vxe-column title="创建时间" field="createTime"></vxe-column>
        <vxe-column title="检测点高度(m)" field="height"></vxe-column>

        <vxe-column title="操作" field="operate" align="right" v-if="couldEdit">
          <template #default="{ row }">
            <a-button type="link" @click="() => handleAddEditItem(row)">修改</a-button>
            <a-button type="link" @click="() => handleDeleteItem(row)">删除</a-button>
          </template>
        </vxe-column>
      </vxe-table>
    </div>

    <AddEditItemDialog :tip="numberTip" ref="AddEditItemDialog" @successed="updateTableAndTree"></AddEditItemDialog>
  </a-card>
</template>

<script>
import ApiController from '@/views/report/api/point'
import { getPointMaxNumber } from '../../api/functionApi'
import { TableMixin } from '@/views/report/_mixin'
import AddEditItemDialog from './AddEditItemDialog'

export default {
  mixins: [TableMixin],
  components: {
    AddEditItemDialog
  },
  data() {
    return {
      ApiController,
      maxLimit: undefined
    }
  },
  computed: {
    recordCount() {
      return this.tableData.length
    },
    // 检测点提示
    numberTip() {
      return `检测点${this.recordCount + 1}/${this.maxLimit || 0}`
    }
  },
  mounted() {
    this.fetchMaxLimit()
  },
  methods: {
    // 获取最大数量限制
    async fetchMaxLimit() {
      const params = { id: this.$route.params.id }
      const data = await getPointMaxNumber(params)
      this.maxLimit = data.max
    },
    // 添加
    handleAdd() {
      if (this.recordCount >= this.maxLimit) {
        this.$message.warning(`检测点数量已达上限 ${this.maxLimit}，无法新增!`)
        return
      }

      this.handleAddEditItem() // mixin
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
